import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { PoleEmploiContractMapping } from '@models/pole-emploi/contract';

@Pipe({ name: 'typeContrat' })
export class TypeContratPipe implements PipeTransform {
  transform(htmlContent: string): any {
    return PoleEmploiContractMapping[htmlContent] || htmlContent;
  }
}

@NgModule({
  declarations: [TypeContratPipe],
  exports: [TypeContratPipe],
  providers: [TypeContratPipe],
  imports: [CommonModule],
})
export class TypeContratModule {}
